import { AuthRoles } from '../../config';
import { LanguagesEnum } from '../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  page_title: {
    [LanguagesEnum.Greek]: 'VAT Return Details',
    [LanguagesEnum.English]: 'VAT Return Details',
  },
  subtitle1: {
    [LanguagesEnum.Greek]: 'Review VAT Return Form',
    [LanguagesEnum.English]: 'Review VAT Return Form',
  },
  subtitle2: {
    [LanguagesEnum.Greek]:
      'You can review the selected VAT Return Details below. Using the form below and the available action buttons on the right section of the Header Title Bar, you can complete any missing required details, you can make any necessary Updates and you can Submit the VAT Return Form accordingly for Processing by the Tax Administration.',
    [LanguagesEnum.English]:
      'You can review the selected VAT Return Details below. Using the form below and the available action buttons on the right section of the Header Title Bar, you can complete any missing required details, you can make any necessary Updates and you can Submit the VAT Return Form accordingly for Processing by the Tax Administration.',
  },
  action_temporary_save: {
    [LanguagesEnum.Greek]: 'ΠΡΟΣΩΡΙΝΗ ΑΠΟΘΗΚΕΥΣΗ',
    [LanguagesEnum.English]: 'SAVE TEMPORARY',
  },
  action_final_submit: {
    [LanguagesEnum.Greek]: 'ΥΠΟΒΟΛΗ',
    [LanguagesEnum.English]: 'FINAL SUBMIT',
  },
  action_submit_nil: {
    [LanguagesEnum.Greek]: 'Submit Nil',
    [LanguagesEnum.English]: 'Submit Nil',
  },
  add_supply: {
    [LanguagesEnum.English]: 'Add Supply',
    [LanguagesEnum.Greek]: 'Add Supply',
  },
  add_correction: {
    [LanguagesEnum.English]: 'Add Correction',
    [LanguagesEnum.Greek]: 'Add Correction',
  },
};

export const allowedActions = {
  temporary: {
    state_status: ['0N'],
    roles: AuthRoles.Registered,
  },
  final: {
    state_status: ['0N'],
    roles: AuthRoles.Registered,
  },
  isNil: {
    state_status: ['0N'],
    roles: AuthRoles.Registered,
  },
};

export interface FormFields {
  // IDENTIFICATION DETAILS
  identificationDetails_vatNumber: string | null;
  identificationDetails_companyName: string | null;
  identificationDetails_vatReturnId: number | null;
  identificationDetails_vatReturnVersionId: number | null;
  identificationDetails_vatReturnReference: number | null;
  // VAT RETURN PERIOD DETAILS
  vatReturnPeriodDetails_vatReturnPeriod: string | null;
  vatReturnPeriodDetails_vatReturnSubmissionDate: string | null;
  vatReturnPeriodDetails_vatReturnVersion: string | null;
  vatReturnPeriodDetails_year: number | null;
  vatReturnPeriodDetails_startDate?: Date | null;
  vatReturnPeriodDetails_endDate?: Date | null;
}

export const initialDefaultValues: FormFields = {
  // IDENTIFICATION DETAILS
  identificationDetails_vatNumber: null,
  identificationDetails_companyName: null,
  identificationDetails_vatReturnId: null,
  identificationDetails_vatReturnVersionId: null,
  identificationDetails_vatReturnReference: null,
  // VAT RETURN PERIOD DETAILS
  vatReturnPeriodDetails_vatReturnPeriod: null,
  vatReturnPeriodDetails_vatReturnSubmissionDate: null,
  vatReturnPeriodDetails_vatReturnVersion: null,
  vatReturnPeriodDetails_year: null,
  vatReturnPeriodDetails_startDate: null,
  vatReturnPeriodDetails_endDate: null,
};

export default CONFIGURATION;
